/* eslint-disable */
import carousel from 'vue-owl-carousel'
const $ = window.jQuery = require('jquery');  
export default {
  name: 'our-app-page-info',
  components: {
    carousel,
  },
  props: [],
  data () {
    return {
      comingSoonPopupState:false
    }
  },
  computed: {

  },
  mounted () {

  },
  methods: {
   comingSoonPopupOpen(){
      this.comingSoonPopupState = true
      document.body.classList.add('body_right_scroll_remove')
    },
    comingSoonPopupClosed(){
      this.comingSoonPopupState = false
      document.body.classList.remove('body_right_scroll_remove')
    }

  },
  beforeCreate: function() {
    $('body').addClass('left_sidebaar_disabled_for_page')
    $('body').addClass('public_page_for_wrp_img')
  },
  beforeRouteLeave: function (to, from, next) {
    $('body').removeClass('left_sidebaar_disabled_for_page')
    $('body').removeClass('public_page_for_wrp_img')
    $(window).scrollTop(0);
    next();
  },
}